const clientId = process.env.REACT_APP_ENTRA_CLIENT_ID;
const tenantId = process.env.REACT_APP_ENTRA_TENANT_ID;

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};
